import React from 'react';
import Icon from '../../../components/AppIcon';

const FormProgressIndicator = ({ completionPercentage, completedSections }) => {
  const sections = [
    { id: 'customer', label: 'Customer Info', icon: 'User' },
    { id: 'property', label: 'Property Info', icon: 'Home' },
    { id: 'referral', label: 'Referral Info', icon: 'Tag' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground">Form Progress</h3>
        <span className="text-sm font-medium text-primary">{completionPercentage}% Complete</span>
      </div>
      <div className="w-full bg-muted rounded-full h-2 mb-4">
        <div 
          className="bg-primary h-2 rounded-full transition-all duration-300"
          style={{ width: `${completionPercentage}%` }}
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        {sections?.map((section) => (
          <div key={section?.id} className="flex items-center gap-2">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 ${
              completedSections?.[section?.id] 
                ? 'bg-success/10' :'bg-muted'
            }`}>
              <Icon 
                name={completedSections?.[section?.id] ? 'CheckCircle' : section?.icon} 
                size={16} 
                color={completedSections?.[section?.id] ? 'var(--color-success)' : 'var(--color-muted-foreground)'} 
              />
            </div>
            <span className={`text-xs font-medium ${
              completedSections?.[section?.id] ? 'text-success' : 'text-muted-foreground'
            }`}>
              {section?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormProgressIndicator;